import {RecruitSourcesList} from "./RecruitSourcesList";
import {RecruitSourcesEdit} from "./RecruitSourcesEdit";
import {RecruitSourcesCreate} from "./RecruitSourcesCreate";

export default {
    list: RecruitSourcesList,
    create: RecruitSourcesCreate,
    edit: RecruitSourcesEdit
};
